import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

type Description =
  | 'dueNow'
  | 'inReview'
  | 'updateSoon'
  | 'rejected'
  | 'upToDate';

export interface StatusDescriptionModalData {
  enabledStatusDescriptions: Array<Description>;
}

@Component({
  selector: 'ui-status-description-modal',
  templateUrl: './status-description-modal.component.html',
  styleUrls: ['./status-description-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusDescriptionModalComponent implements OnInit {
  public multipleKeyIndicatorsEnabled = false;
  public statusDescriptionEnabledConfig: Record<Description, boolean> = {
    dueNow: false,
    inReview: false,
    updateSoon: false,
    rejected: false,
    upToDate: false,
  };

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private _dialogData: StatusDescriptionModalData,
    private _matDialogRef: MatDialogRef<StatusDescriptionModalComponent>,
  ) {}

  public ngOnInit(): void {
    let count = 0;
    this._dialogData.enabledStatusDescriptions.forEach((description) => {
      if (description in this.statusDescriptionEnabledConfig) {
        this.statusDescriptionEnabledConfig[description] = true;
        count++;
      }
    });
    this.multipleKeyIndicatorsEnabled = count > 1;
  }

  public closeModal(): void {
    this._matDialogRef.close();
  }
}
